const templateLibrary = [
  {
    id: 'ecommerce',
    title: 'E-commerce Growth',
    description: 'Revenue, product performance, and channel mix.',
    icon: 'shopping',
    premium: true,
    recommendedColumns: ['order_date', 'order_total', 'product', 'channel', 'customer_segment'],
    questions: [
      {
        question: 'What is total revenue by month?',
        description: 'Track monthly sales trends.'
      },
      {
        question: 'Which products generate the most revenue?',
        description: 'Identify top-performing products.'
      },
      {
        question: 'What is average order value by channel?',
        description: 'Compare order value across channels.'
      },
      {
        question: 'How does revenue break down by customer segment?',
        description: 'See which segments drive sales.'
      }
    ]
  },
  {
    id: 'finance',
    title: 'Finance Pulse',
    description: 'Cash flow, spend concentration, and variance.',
    icon: 'finance',
    premium: true,
    recommendedColumns: ['date', 'amount', 'category', 'vendor', 'type'],
    questions: [
      {
        question: 'What is total spend by category?',
        description: 'Understand major expense areas.'
      },
      {
        question: 'Which vendors receive the most spend?',
        description: 'Spot concentration risks.'
      },
      {
        question: 'How does cash inflow vs outflow change over time?',
        description: 'Track net cash movement.'
      },
      {
        question: 'What are the largest transactions this quarter?',
        description: 'Highlight large payments.'
      }
    ]
  },
  {
    id: 'operations',
    title: 'Operations Efficiency',
    description: 'Throughput, delays, and bottlenecks.',
    icon: 'ops',
    premium: false,
    recommendedColumns: ['order_date', 'status', 'region', 'duration', 'warehouse'],
    questions: [
      {
        question: 'How many orders are in each status?',
        description: 'Monitor pipeline health.'
      },
      {
        question: 'What is average fulfillment time by warehouse?',
        description: 'Compare operational performance.'
      },
      {
        question: 'Which regions experience the most delays?',
        description: 'Surface bottlenecks by region.'
      },
      {
        question: 'How does throughput change week over week?',
        description: 'Track output trends.'
      }
    ]
  }
];

export default templateLibrary;
